import React from 'react';
import './UserCreatePassword.scss';
import { Redirect, NavLink } from "react-router-dom";
import request from '../../utils/agent';

export default class UserCreatePassword extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            token: this.props.match.params.token,
            action: this.props.match.params.action,
            user: null,
            loading: true,
            errorMessage: null,
            isAuthenticated: false,
            role: null
        };
    }

    componentDidMount() {
        this.getUserInfo();
    }

    getUserInfo = () => {
        request.post('/api/token/verify')
            .send({token: this.state.token})
            .then(resp => {
                let data = resp.body.reset_token.user;
                this.setState({
                    user: {first_name: data.cdata.first_name, last_name: data.cdata.last_name, email: data.email},
                    loading: false
                });
            })
            .catch(err => {
                this.setState({
                    errorMessage: "This token is invalid or has been used", 
                    loading: false
                });
            })

    }

    createPassword = async () => {
        let pass1 = this.refs.pass1.value;
        let pass2 = this.refs.pass2.value;

        if(pass1 !== pass2) {
            this.setState({
                errorMessage: "Passwords do not match"
            });
            return;
        }

        // Let's set the password now
        var [err] = await this.setPassword(pass1);
        console.log(err);
        if(err) {
            this.setState({
                errorMessage: "Unable to create password"
            });
            return;
        }

        // Don't auto login users
        let msg = this.state.action === 'create' ? '?msg=Password Created' : '?msg=Password Updated';
        window.document.location.href = `/login${msg}`;

        /**
         * 
         * Following code auto-logins' user after successful password creation. Leaving in case want it back.
        var [err, auth] = await this.props.authHandler.getUserAuth(this.state.user.email, pass1);

        if(err || auth.statusCode !== 200 || auth.body.error) {
            this.setState({errorMessage: "Unable to finalize your account"});
            return;
        } 
        this.props.authHandler.setAuth(auth.body.token);

        var [err, role] = await this.props.authHandler.getUserRole();
        this.setState({
            isAuthenticated: this.props.authHandler.isAuthenticated,
            role: role.role.name
        });
        */
    }

    setPassword = (pass) => {
        return request.post('/api/password/reset')
            .send({
                token: this.state.token,
                password: pass
            })
            .then(resp => [null]) // No data is actually returned
            .catch(err => [err])
    }

    render() {
        if(!this.state.token) {
            return <Redirect to='/404' />
        }

        if(this.state.loading || !this.state.user) {
            return null; // Just hide page for now
        }

        const actionBtn = this.state.action === 'create' ? 'Create Account' : 'Reset';

        // if(this.state.isAuthenticated) {
        //     if(this.state.role === 'owner' || this.state.role === 'admin' || this.state.role === 'pOwner') {
        //         return <Redirect to='/admin' />;
        //     }
        //     return <Redirect to='/user' />
        // }

        return(
            <section className="site-centered">
                <div className="row justify-content-md-center">
                    <div id="login-form" className="col-sm-6 col-sm-offset-3 col-xs-12">
                        <div className="panel panel-default panel-logged-out">
                            {this.state.action === 'create' &&
                                <div className="panel-heading create">
                                    {this.state.role === 'installer' && 
                                        <section>
                                        <h3 className="panel-title">Noon Pro Portal</h3>
                                        <p>By entering a password and creating an account you agree to:</p>
                                        <p>
                                            <ul>
                                                <li>Join { dealer_name /* Where does this come from? */ }</li>
                                            </ul>
                                        </p>
                                        </section>
                                    }
                                    {this.state.role !== 'installer' && 
                                        <section>

                                            <h3 className="panel-title">Welcome to the NOON Pro Portal, {this.state.user.first_name}!</h3>
                                            <p>Please create your password below</p>
                                        </section>
                                    }

                                </div>
                            }
                            {this.state.action === 'reset' && 
                                <div className="panel-heading create">
                                    <section>
                                        <h3 className="panel-title">Hello {this.state.user.first_name} {this.state.user.last_name}</h3>
                                        <p>Please enter a new password below</p>
                                    </section>
                                </div>
                            }
                            <div className="panel-body">
                                {this.state.errorMessage && 
                                    <div className="alert alert-danger">
                                        { this.state.errorMessage }
                                    </div>
                                }
                                <div className="form-group">
                                    <input type="password" ref="pass1" name="pass1" className="form-control" placeholder="Password"/>
                                </div>
                                <div className="form-group">
                                    <input type="password" ref="pass2" name="pass2" className="form-control" placeholder="Repeat Password"/>
                                </div>

                                <button onClick={this.createPassword} className="btn btn-default btn-primary">{actionBtn}</button>
                                {this.state.action === 'reset' &&
                                    <NavLink className="btn btn-default btn-primary btn-gray" to="/login">Back to Log In</NavLink>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/routes/UserCreatePassword/index.js